<template>
	<div>	
		<reportBoardView v-if="user.userLevel > 80 "/>
		<reportAdminView v-else />
	</div>
</template>
<script>
import { HTTP } from "../axios.js";
import momentTH from 'moment/src/locale/th' 
import moment from 'moment'
import reportAdminView from '@/components/ReportCompanyAdminView'
import reportBoardView from '@/components/ReportCompanyBoardView'
	export default{
		components:{
			reportAdminView,
			reportBoardView
		},
		data(){
			return{
				searchEmail:'',
				searchTel:'',
				searchLastName:'',
				dateNow:new Date(),
				searchName:'',
				staffLists:[],
				imgUrl: process.env.VUE_APP_IMAGE_URL,
				currentSort: "",
				currentSortDir: "desc",
				widthMax: window.innerWidth,
				companyList:[],
				rangeEndDate:[],
				rangeStartDate:[],
				searchCompany: null,
				searchTypeBusiness: null,
				searchLevelBusiness: null,
				searchlastLogin: null,
			}
		},
		created(){

		},
		methods:{

		},
		computed: {
		    user() {
		      return this.$store.state.user;
		    },
		    batch() {
		      return this.$store.state.batch;
		    },
		    token() {
		      return this.$store.state.token;
		    },
		    getRule() {
		      return this.$store.state.rule;
		    }
		  }
	}
</script>
<style scoped>
	.border-radius{
	    display: flex;
	    border-radius: 50%;
	    align-items: center;
	    width: 28px;
	    justify-content: center;
	    /* height: 28px; */
	    color: #e1e1e1;
	    border: 2px solid #e1e1e1;
	}
	.border-radius.active{
		background-color: #02A8A0;
		border:1px solid #02A8A0;
		color: #fff;
	}
	.border-radius.active .icon{
		color: #fff;
	}
</style>